import type { PartialCancellationRequestPayload } from '../../domain/types'
import type { CancelBookingFormValues } from '@/scopes/account/booking-details/pages/components/CancelBookingAction/types'

interface PartialCancellationRequestPayloadMapperInput {
  formValues: CancelBookingFormValues
  isMainBookerCancelled: boolean
}

export function partialCancellationRequestPayloadMapper({
  formValues,
  isMainBookerCancelled,
}: PartialCancellationRequestPayloadMapperInput): PartialCancellationRequestPayload {
  const payload: PartialCancellationRequestPayload = {
    participants: formValues.participantIds.map(Number),
    remarks: formValues.roomLayoutPreference,
    quoteRequest: formValues.requestPriceQuote,
  }

  if (isMainBookerCancelled) {
    payload.newMainBookerName = formValues.newMainBooker.name
    payload.newMainBookerEmail = formValues.newMainBooker.email
  }

  return payload
}
